import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import TextBlock from '@/modules/base/components/texts/text-block'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@mui/styles'
import lang from 'lang'
import { DateInput } from '@/modules/base/components/inputs/index'
import { submitCompanyData, fetchCompanyData } from '@/redux/ducks/settings/company'
import IconCheck from 'assets/images/icons/check.svg'
import { Formik, Form } from 'formik'
import { ButtonIconSquare } from '@/modules/base/components/buttons'
import { USER_RIGHTS } from '@/modules/base/util/constants'
import useCheckAccessRights from '@/modules/_helpers/accessCheck/useCheckAccessRights'
import useClientSetting from '@/modules/client/_helpers/useClientSetting'

const FiscalYear = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { onSave, refresh } = props

  const companyData = useSelector(store => store.settings.company)
  const { client } = useClientSetting()
  const { isLoading } = companyData

  const readOnly = !useCheckAccessRights(USER_RIGHTS.SETTINGS.WRITE)

  useEffect(() => {
    dispatch(fetchCompanyData(client?.id))
  }, [refresh])

  const handleSubmit = (values, { setSubmitting }) => {
    dispatch(submitCompanyData({ ...values }, true, client?.id))
    setSubmitting(false)
    onSave && onSave()
  }

  return (
    <Formik
      initialValues={companyData}
      onSubmit={handleSubmit}
      enableReinitialize={true}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <div>
              <div className={classes.fiscalYearTitleBox}>
                <div className={classes.title}>{lang.settings.taxes.fiscalYearTitle}</div>
                <TextBlock>{lang.settings.taxes.fiscalYearText}</TextBlock>
                <div className={classes.fiscalYearInputWrapper}>
                  <DateInput
                    useFormik
                    name='beginningOfFiscalYear'
                    label={lang.settings.taxes.beginningOfFiscalYearLabel}
                    format='DD.MM'
                    placeholder='TT.MM'
                    readOnly={readOnly}
                    isLoading={isLoading}
                    required />
                </div>
              </div>
              <div className={classes.buttonRow}>
                <ButtonIconSquare
                  customClass={classes.button}
                  label={lang.saveButtonLabel}
                  icon={IconCheck}
                  type='submit'
                  disabled={readOnly || isLoading || isSubmitting}
                  dataQsId='settings-mycompany-tax-fiscalYear-save'
                />
              </div>

            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

FiscalYear.propTypes = {
  onSave: PropTypes.func,
  refresh: PropTypes.bool,
}

FiscalYear.defaultProps = {
  onSave: () => {},
  refresh: false,
}

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.smedium,
    marginBottom: 30,
  },
  fiscalYearTitleBox: {
    marginTop: 0,
  },
  fiscalYearInputWrapper: {
    width: '100%',
  },
  buttonRow: {
    paddingTop: 30,
  },
  button: {
    marginLeft: 'auto',
  },
}))

export default FiscalYear
